module.exports = __webpack_public_path__ + "img/bookmark_on.2eaa563b.svg";